import { TypedUseSelectorHook, useSelector as useSelectorR, useDispatch as useDispatchR } from 'react-redux'
import { StoreDispatch, TStore } from '../@types/redux'

export const useSelector: TypedUseSelectorHook<TStore> = useSelectorR
export const useDispatch: StoreDispatch = useDispatchR
